import React from 'react';
import {WithTranslationProps} from 'react-i18next';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';
interface BusinessCoach {
  firstName: string;
  lastName: string;
}
interface Item {
  activatedOn: string;
  businessCoach: BusinessCoach;
}
interface CoachSponsorProps extends WithTranslationProps {
  item: Item | null;
}

export const CoachSponsor: React.FC<CoachSponsorProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = null,
}) => {
  const dateUtil = getDateUtilDefaultInstance();
  const activatedOn = get(item, 'activatedOn', {});
  const firstName = get(item, 'businessCoach.firstName', {});
  const lastName = get(item, 'businessCoach.lastName', {});

  const formattedActivationDate = dateUtil.formatRelativeDate(
    activatedOn,
    'MMM d',
  );

  return (
    <Text testID={Reports.reportClientSponsoredOn}>
      {getDateUtilDefaultInstance().isDateWithinRelativeRange(activatedOn)
        ? tt(
            'onRelativeDate',
            generateComponentCallback({
              component: (
                <>
                  Sponsored {formattedActivationDate} by {firstName} {lastName}
                </>
              ),
            }),
          )
        : tt(
            'onAbsoluteDate',
            generateComponentCallback({
              component: (
                <>
                  Sponsored on {formattedActivationDate} by {firstName}{' '}
                  {lastName}
                </>
              ),
            }),
          )}
    </Text>
  );
};

export default withTranslation('report.record.coachSponsor')(CoachSponsor);
